import type { Category } from '@ilteducation/content-ref-data-types';

export const useGrades = () => {
  const gradeAbbreviationMap = {
    '6jY8P4D5wRtKyCU5U1Zkv': 'F-3',
    '2BLVY3NYNM8SyQJPKQvr6': '1-3',
    DJrIV1QShY0k6QG4l9FFG: '3-6',
    JTx3E02j0TXCUfS2vCXUt: '4-6',
    AFSfZYj8Sf4FbpIgYCgyA: '5-7',
    xUFNWrwMTDjkOGT8H5MJW: '7-9',
    V64SvpYHVfCWFtQiTDTYB: '8-10',
    TAxhV2ll3Rk38v9S3BBkX: 'Gy',
    pF4RzCLcV2jxr9PxG91Ez: 'Gy',
  }; // TODO a cleaner way to do this..

  const gradeAbbreviation = (grade: Category) => {
    return gradeAbbreviationMap[grade.id as keyof typeof gradeAbbreviationMap] || grade.category;
  };

  return {
    gradeAbbreviation,
  };
};
